import { Spin } from 'antd';
import React from 'react';
import './Spinner.less';

export function Spinner() {
  return <Spin className="spinner__wrapper" />;
}
